// const mainUrl = "http://localhost:5000";

const mainUrl = "https://backend.skyhouse.mn"

//auth urls
export const org_uri = mainUrl + "/org";
export const loginUri = mainUrl + "/admin";
export const logoutUri = mainUrl + "/org";

export const utils_uri = mainUrl + "/utils";
export const products_uri = mainUrl + "/products";
export const orders_uri = mainUrl + "/orders";
export const users_uri = mainUrl + "/users";
export const belen_uri = mainUrl + "/belen";
